import { type OpenApiSchemaErrorCode } from '../../api/schema';
import { isErrorWithType, isRequestError } from '../requests';
import { showError } from '../toast';

type ErrorResponseType = 'integration-access-denied' | 'unsupported-integration-type';
type ErrorTexts = Record<'label' | 'description', string>;

const isErrorResponse = isErrorWithType<ErrorResponseType>;

const errorTypeMap: Record<ErrorResponseType, ErrorTexts> = {
    'integration-access-denied': {
        label: 'Невалидный токен',
        description: 'Токен для выполнения операции невалиден, необходимо сгенерировать новый с нужными правами.',
    },
    'unsupported-integration-type': {
        label: 'Неподдерживаемый тип интеграции',
        description: 'Тип интеграции не поддерживается, необходимо выбрать другой тип интеграции.',
    },
};

const errorCodeMap: Partial<Record<OpenApiSchemaErrorCode, string>> = {
    bad_request: 'Ошибка запуска интеграции',
    forbidden: 'Проверьте права доступа',
};

const defaultErrorTexts: ErrorTexts = {
    label: 'Произошла непредвиденная ошибка при обновлении настроек интеграции.',
    description: 'Пожалуйста, повторите попытку позже.',
};

export const handleUpdateIntegrationSettingsError = (error: unknown) => {
    let { label, description } = defaultErrorTexts;

    if (isErrorResponse(error)) {
        const texts = errorTypeMap[error.responseData.type];

        if (texts) {
            ({ label, description } = texts);
        }
    }

    if (isRequestError(error)) {
        if (error.responseData.code in errorCodeMap) {
            label = errorCodeMap[error.responseData.code] as string;
        }

        description = error.responseData.message;
    }

    showError({ label }, description);
};
